/* Demo Mode only - lightweight lookup of which Menus reference a given RecipeV2 recipe.
 * No backend persistence exists for Menus yet; menuId values line up with the seed data in
 * src/mocks/data/menusData.ts so links from Recipe > Usage resolve to a real Menu detail page.
 *
 * Every one of the 25 British Kitchen recipes (601-625) is used somewhere across the "Autumn
 * at the Table" 5-day cycle (menuId 1) - status is 'Scheduled' for all of them because the
 * menu itself hasn't gone live yet (see menusData.ts / the 6-site trial start date). */

export interface RecipeMenuUsage {
  menuId: number;
  menuName: string;
  siteName: string;
  servicePeriod: string;
  status: string;
}

const recipeUsageByRecipeId: Record<number, RecipeMenuUsage[]> = {
  601: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  602: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  603: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  604: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  605: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  606: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  607: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  608: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  609: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  610: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  611: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  612: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  613: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  614: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  615: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  616: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  617: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  618: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  619: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  620: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  621: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  622: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  623: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  624: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
  625: [
    { menuId: 1, menuName: 'Autumn at the Table', siteName: 'All 6 British Kitchen trial sites', servicePeriod: 'Lunch', status: 'Scheduled' },
  ],
};

/** Returns the menus a recipe is used in. Empty array means "not currently used in any
 * planned or live menu" - a genuinely useful signal for Item Rationalisation. */
export const getMenuUsageForRecipe = (recipeId: number): RecipeMenuUsage[] => recipeUsageByRecipeId[recipeId] ?? [];
